module.exports = __webpack_public_path__ + "img/sudameris.429a4e41.svg";